import {
    UNSUPPORTED,
    getPlatformInfoClientHints,
    isUserAgentClientHintsSupported,
    platformInfo,
} from '@lingoda/user-agent';
import { setLogContext } from './logScope';

export const setPlatformLogContext = async (): Promise<void> => {
    setLogContext({
        platformInfo,
        deviceMemory: navigator.deviceMemory ?? UNSUPPORTED,
        cpuLogicalCores: navigator.hardwareConcurrency,
    });

    const clientHintsApi = isUserAgentClientHintsSupported()
        ? await getPlatformInfoClientHints()
        : UNSUPPORTED;
    setLogContext({ clientHintsApi });
};
